@if (loaded) {
  <div class="confirm-container">
    <span mat-dialog-title>Add Tax Credit Application</span>
    <div mat-dialog-content>
      <div class="application-type">
        <b class="app-title">Application Type: </b>
        <mat-radio-group
          aria-label="Select an Applicaion Type"
          [(ngModel)]="isFundingRound"
          color="primary"
          >
          <mat-radio-button [value]="true" (click)="clearData()"
            >Funding Round</mat-radio-button
            >
            <mat-radio-button [value]="false" (click)="clearData()"
              >Other</mat-radio-button
              >
            </mat-radio-group>
          </div>
          @if (isFundingRound !== null) {
            <form>
              <mat-form-field appearance="fill" class="hda-spacing">
                <mat-label>HDA</mat-label>
                <input
                  type="text"
                  placeholder="Name of HDA"
                  aria-label="Name of HDA"
                  matInput
                  [formControl]="myControl"
                  [matAutocomplete]="auto"
                  required
                  />
                <mat-autocomplete #auto="matAutocomplete">
                  @for (option of filteredOptions | async; track option) {
                    <mat-option
                      [value]="option"
                      (click)="checkFundingRound()"
                      >
                      {{ option }}
                    </mat-option>
                  }
                </mat-autocomplete>
              </mat-form-field>
              @if (!myControl.value) {
                <div class="row">
                  <div class="col-md-12">
                    <small class="error-text">Enter the name of the HDA</small>
                  </div>
                </div>
              }
            </form>
          }
          @if (
            isFundingRound &&
            orgid !== '' &&
            fundingRounds &&
            fundingRounds.length > 0
            ) {
            <div
              >
              <div class="row space-between gutters">
                <div class="col-md-6">
                  <mat-form-field>
                    <mat-label>Year</mat-label>
                    <mat-select [(value)]="yearIndex" required>
                      @for (year of fundingRounds; track year; let i = $index) {
                        <mat-option
                          [value]="i"
                          >{{ year.year }}</mat-option
                          >
                        }
                      </mat-select>
                    </mat-form-field>
                    @if (yearIndex === null) {
                      <div class="row">
                        <div class="col-md-12">
                          <small class="error-text">
                            Select Year for the Funding Round
                          </small>
                        </div>
                      </div>
                    }
                  </div>
                  <div class="col-md-6">
                    @if (yearIndex !== null) {
                      <mat-form-field>
                        <mat-label>Round</mat-label>
                        <mat-select [(value)]="roundIndex">
                          @for (
                            round of fundingRounds[yearIndex].rounds; track
                            round; let i = $index) {
                            <mat-option
                              [value]="i"
                              >{{ round.number }}</mat-option
                              >
                            }
                          </mat-select>
                        </mat-form-field>
                      }
                      @if (yearIndex !== null && roundIndex === null) {
                        <div class="row">
                          <div class="col-md-12">
                            <small class="error-text">
                              Select Round for the Funding Round
                            </small>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                  @if (yearIndex !== null && roundIndex !== null) {
                    <div
                      class="row space-between gutters round-info"
                      >
                      <div class="col-md-6">
                        <b>Application Due Date: </b
                          >{{ fundingRounds[yearIndex].rounds[roundIndex].due }}
                        </div>
                        <div class="col-md-6">
                          <b>Award Date: </b
                            >{{ fundingRounds[yearIndex].rounds[roundIndex].award }}
                          </div>
                        </div>
                      }
                    </div>
                  }
                  @if (
                    (isFundingRound === false && orgid !== '') ||
                    (isFundingRound && yearIndex !== null && roundIndex !== null)
                    ) {
                    <div
                      >
                      <mat-form-field appearance="fill">
                        <mat-label>Choose a Credit Type</mat-label>
                        <mat-select [(value)]="creditType" required>
                          @for (type of creditsList; track type) {
                            <mat-option [value]="type">{{
                              type.name
                            }}</mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                      @if (!creditType) {
                        <div class="row">
                          <div class="col-md-12">
                            <small class="error-text">
                              Choose a Credit Type
                            </small>
                          </div>
                        </div>
                      }
                      <div class="awarded-row">
                        <b>Awarded: </b>
                        <mat-radio-group
                          aria-label="Select an Application Type"
                          [(ngModel)]="isAwarded"
                          >
                          <mat-radio-button [value]="true">Awarded</mat-radio-button>
                          <mat-radio-button [value]="false">Not Awarded</mat-radio-button>
                        </mat-radio-group>
                        <button mat-icon-button class="undo-button" (click)="isAwarded = null">
                          <mat-icon>undo</mat-icon>
                        </button>
                      </div>
                      <div class="row space-between gutters">
                        <div class="col-md-6">
                          <mat-form-field>
                            <mat-label>Full Credit Amount</mat-label>
                            <input [(ngModel)]="amount" matInput type="number" />
                          </mat-form-field>
                        </div>
                        <div class="col-md-6">
                          <mat-form-field>
                            <mat-label>Request Date</mat-label>
                            <input
                              matInput
                              [matDatepicker]="picker"
                              [(ngModel)]="requestDate"
                              />
                            <mat-datepicker-toggle
                              matIconSuffix
                              [for]="picker"
                            ></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  }
                </div>
                <div mat-dialog-actions style="float: right; margin: 20px">
                  <button
                    mat-button
      [mat-dialog-close]="{
        clicked: 'Ok',
        orgid: !isFundingRound ? orgid : null,
        fundingRoundID:
          isFundingRound && yearIndex !== null && roundIndex !== null
            ? fundingRounds[yearIndex].rounds[roundIndex].id
            : null,
        taxCreditID: creditType ? creditType.typeid : null,
        taxCreditDesignationID: creditType ? creditType.designationid : null,
        awarded: isAwarded,
        amount: amount,
        request_date: requestDate
      }"
      [disabled]="
        isFundingRound === null ||
        orgid === '' ||
        !creditType ||
        (isFundingRound && (yearIndex === null || roundIndex === null))
      "
                    >
                    Ok
                  </button>
                  <button mat-button (click)="onNoClick()">Cancel</button>
                </div>
              </div>
            }
